<section
  class="portfolio-kpi-chart-card"
  [ngClass]="[
    'portfolio-kpi-chart-card--' + variant,
    'portfolio-kpi-chart-card--' + variant + '-' + cardType,
    !framed ? 'portfolio-kpi-chart-card--unframed' : ''
  ]"
>
  <header *ngIf="showHeader" class="portfolio-kpi-chart-card-header">
    <h3>{{ title }}</h3>
    <div class="portfolio-kpi-chart-card-icons">
      <ng-container *ngIf="cardType === 'cycle'; else defaultInfoIcon">
        <mat-icon
          svgIcon="info"
          class="portfolio-kpi-chart-card-icon portfolio-kpi-chart-card-icon--interactive"
          cdkOverlayOrigin
          #cycleInfoOrigin="cdkOverlayOrigin"
          (mouseenter)="onCycleInfoEnter()"
          (mouseleave)="onCycleInfoLeave()"
          (click)="onCycleInfoToggle()"
        ></mat-icon>
        <cds-tooltip
          [origin]="cycleInfoOrigin"
          [open]="cycleInfoTooltipOpen"
          placement="left"
          [panelWidth]="256"
          [hasBackdrop]="false"
          (hovered)="onCycleInfoEnter()"
          (unhovered)="onCycleInfoLeave()"
        >
          <ng-template #tooltipContent>
            <div class="portfolio-kpi-chart-card-cycle-tooltip-title">{{ cycleInfoTitle }}</div>
            <div>{{ cycleInfoText }}</div>
          </ng-template>
        </cds-tooltip>
      </ng-container>
      <ng-template #defaultInfoIcon>
        <ng-container *ngIf="hasInfoTooltip; else staticInfoIcon">
          <mat-icon
            svgIcon="info"
            class="portfolio-kpi-chart-card-icon portfolio-kpi-chart-card-icon--interactive"
            cdkOverlayOrigin
            #infoOrigin="cdkOverlayOrigin"
            (mouseenter)="onInfoEnter()"
            (mouseleave)="onInfoLeave()"
            (click)="onInfoToggle()"
          ></mat-icon>
          <cds-tooltip
            [origin]="infoOrigin"
            [open]="infoTooltipOpen"
            placement="left"
            [panelWidth]="256"
            [hasBackdrop]="false"
            (hovered)="onInfoEnter()"
            (unhovered)="onInfoLeave()"
          >
            <ng-template #tooltipContent>
              <div *ngIf="infoTooltipTitle" class="portfolio-kpi-chart-card-cycle-tooltip-title">
                {{ infoTooltipTitle }}
              </div>
              <div>{{ infoTooltipText }}</div>
            </ng-template>
          </cds-tooltip>
        </ng-container>
        <ng-template #staticInfoIcon>
          <mat-icon svgIcon="info" class="portfolio-kpi-chart-card-icon"></mat-icon>
        </ng-template>
      </ng-template>
      <button
        *ngIf="variant === 'expanded'"
        type="button"
        class="portfolio-kpi-chart-card-expand-btn"
        (click)="onExpand()"
      >
        <mat-icon svgIcon="enlarge" class="portfolio-kpi-chart-card-icon"></mat-icon>
      </button>
    </div>
  </header>
  <div *ngIf="cardType === 'cycle'" class="portfolio-kpi-chart-card-cycle-wrapper">
    <ng-container *ngIf="!isLoading; else cycleChartLoading">
      <time-cycle-chart [chartData]="timeCycleChartData" [size]="cycleChartSize"></time-cycle-chart>
    </ng-container>
    <ng-template #cycleChartLoading>
      <div class="portfolio-kpi-chart-card-cycle-skeleton">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{
            width: '100%',
            height: '100%',
            'border-radius': '4px',
            display: 'block',
            margin: '0'
          }"
          style="width: 100%; height: 100%; display: block"
        ></ngx-skeleton-loader>
      </div>
    </ng-template>
  </div>
  <div
    *ngIf="cardType === 'summary'"
    class="portfolio-kpi-chart-card-chart-wrapper"
    #summaryChartContainer
  >
    <ng-container *ngIf="!isLoading; else summaryChartLoading">
      <div
        echarts
        (chartInit)="onChartInit($event)"
        (chartClick)="onSummaryChartClick($event)"
        [options]="summaryChartOption"
        [autoResize]="true"
        class="portfolio-kpi-chart-card-chart"
      ></div>
    </ng-container>
    <ng-template #summaryChartLoading>
      <div class="portfolio-kpi-chart-card-summary-skeleton">
        <ngx-skeleton-loader
          count="1"
          appearance="line"
          [theme]="{
            width: '100%',
            height: '100%',
            'border-radius': '4px',
            display: 'block',
            margin: '0'
          }"
          style="width: 100%; height: 100%; display: block"
        ></ngx-skeleton-loader>
      </div>
    </ng-template>
  </div>
</section>
